module.exports = __webpack_public_path__ + "assets/8f37007755f54225431ca7c1594b466a.mp3";